import type { ReactElement } from "react";
import { NewbornGuideCard } from "./components/NewbornGuideCard";
import { SectionCta } from "./components/SectionCta";
import { newbornGuides } from "./data/newborn.data";
import { resourceArticles } from "./data/resourceArticles";
import "./NewbornPages.scss";
import newbornHeroImage from "../../assets/images/Hero/newborn-photography-guides-hero.webp";
import { ResourceHubSeo } from "./ResourceSeo";

const publishedNewbornGuideHrefs = new Set(
  resourceArticles
    .filter((article) => article.category === "newborn")
    .map((article) => `/resources/${article.category}/${article.slug}/`)
);

const publishedNewbornGuides = newbornGuides.filter((guide) => publishedNewbornGuideHrefs.has(guide.href));

export const NewbornHub = (): ReactElement => (
  <main className="newborn-page">
    <ResourceHubSeo category="newborn" />
    <section className="newborn-hub-hero">
      <img
        alt="Sleeping newborn baby in soft pink wraps"
        className="newborn-hub-hero__background"
        src={newbornHeroImage}
      />

      <div className="newborn-shell newborn-hub-hero__content">
        <nav aria-label="Breadcrumb" className="newborn-breadcrumb">
          <a href="/">Home</a>
          <span>/</span>
          <a href="/resources/">Resources</a>
          <span>/</span>
          <span>Newborn</span>
        </nav>

        <h1>Newborn Photography</h1>

        <p>
          A simple place to find answers before your newborn session — when to book, what to expect, and how to prepare.
        </p>
      </div>
    </section>
    {/*<section className="newborn-hub-hero">*/}
    {/*  <div className="newborn-shell newborn-hub-hero__content">*/}
    {/*    <nav aria-label="Breadcrumb" className="newborn-breadcrumb"><a href="/">Home</a><span>/</span><a href="/resources/">Resources</a><span>/</span><span>Newborn</span></nav>*/}
    {/*    <h1>Newborn Photography</h1>*/}
    {/*    <p>Everything you need to know about newborn photo sessions, from the best age to what to expect and how to prepare.</p>*/}
    {/*  </div>*/}
    {/*  <div aria-label="Replace with a newborn photograph" className="newborn-hub-hero__image newborn-image-placeholder newborn-image-placeholder--peach" role="img" />*/}
    {/*</section>*/}

    <section className="newborn-guides-section newborn-shell">
      <h2>Explore newborn guides</h2>
      <div className={`newborn-guide-grid guide-grid--count-${publishedNewbornGuides.length}`}>
        {publishedNewbornGuides.map((guide) => (
          <NewbornGuideCard guide={guide} key={guide.href} />
        ))}
      </div>
      <SectionCta />
    </section>
  </main>
);

export default NewbornHub;
